/* eslint-disable no-empty-label */
import asyncRoutes from './../../router/asyncRouterMap'
import { personnelMaps, enterpriseMaps } from '../../router/outsourceAsyncMap'
import constRoutes from './../../router/constRoutes'
import componentList from './../../config/componentList'
import Utils from './../../utils'
import Env from './../../utils/env'
import EmptyPage from '@/views/empty/index'
import ApiPermission from './../../apis/permission'

//根据后台返回的page component key
function getAsyncComponent(pageComp) {
  const componentPath = componentList[pageComp]
  if (!componentPath) {
    return EmptyPage
  }
  return view(componentPath)
}

const trees = {
  menu: 0,
  permit: 1,
  page: 2
}

function handleRoute(originRoute = {}) {
  if (originRoute.type === trees.permit) {
    return {
      btnName: originRoute.component,
      isPage: false
    }
  }
  let tmp = {}
  tmp.meta = Utils.tunefulParse(originRoute.metaInfo, {})
  tmp.meta.menuId = originRoute.menuId
  if (originRoute.type === trees.permit) {
    tmp.permissions = originRoute
  } else {
    if (originRoute.component) {
      tmp.name = 'page' + originRoute.menuId
      tmp.pageKey = originRoute.component
      tmp.component = getAsyncComponent(tmp.pageKey)
    }
    tmp.path = originRoute.path
    tmp.menuName = originRoute.menuName
    tmp.extendHidden = tmp.meta.extendHidden || false //当子节点只有一个 是否隐藏子节点
    tmp.meta.redirect && (tmp.redirect = tmp.meta.redirect)
  }
  return {
    ...tmp,
    children: originRoute.children,
    isPage: originRoute.type !== trees.permit
  }
}

function filterRoutes(routes, parent) {
  const asyncRoutes = []
  const asyncPermissions = []
  routes.forEach((route) => {
    const tmp = handleRoute(route)
    tmp.fullPath = parent ? `${parent.fullPath}/${tmp.path}` : tmp.path
    if (tmp.children && tmp.children.length) {
      const child = filterRoutes(tmp.children, tmp)
      if (child.routes && child.routes.length) {
        tmp.children = child.routes
      } else if (child.permissions && child.permissions.length) {
        tmp.meta.permissions = child.permissions
        delete tmp.children
      }
    }
    if (tmp.isPage) {
      asyncRoutes.push(tmp)
    } else {
      asyncPermissions.push(tmp.btnName)
    }
  })
  return {
    routes: asyncRoutes,
    permissions: asyncPermissions
  }
}
function view(path) {
  return function(resolve) {
    //必须这么写 不然会报错， import 函数必须有匹配，即匹配 @ xxx  和  .vue前后匹配
    //或者可以用函数require 函数，但是实现不了懒加载目的
    import(`@/views/${path}.vue`).then((mod) => {
      resolve(mod)
    })
  }
}

function getPathMap(routes, map = new Map()) {
  if (routes && routes.length) {
    routes.forEach((route) => {
      if (route.pageKey && route.fullPath) {
        map.set(route.pageKey, route.fullPath)
      }
      if (route.children) {
        getPathMap(route.children, map)
      }
    })
  }
  return map
}

/**
 * @2019/4/17
 * @author: huiming
 * desc:  用户权限模块
 * 权限为两种类型， 一个是page的权限（往往伴随左侧的side ）然后通过 router拦截
 * 一个是 功能性权限 这个需要全局getter 出去判断
 */
export default {
  state: {
    routes: [],
    addRoutes: [],
    hasSetting: false,
    pathMap: new Map()
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constRoutes.concat(routes)
    },
    SET_SETTING: (state, val = false) => {
      state.hasSetting = val
    },
    SET_PATH_MAP: (state, val) => {
      state.pathMap = val
    }
  },
  getters: {
    userTree: (state) => state.routes || [],
    hasSettingRoutes: (state) => state.hasSetting,
    pathMap: (state) => state.pathMap
  },
  actions: {
    InitRoutes({ commit, getters }, { type }) {
      return new Promise((resolve, reject) => {
        // console.log(accessedRoutes.length)
        if (type === 'provider') {
          ApiPermission.menuTree({})
            .then((res) => {
              let accessedRoutes
              if (Env.isDev() && false) {
                //开发环境直接 add
                accessedRoutes = asyncRoutes
              } else {
                accessedRoutes = filterRoutes(res.result || []).routes
                let map = getPathMap(accessedRoutes)
                commit('SET_PATH_MAP', map)
              }
              commit('SET_ROUTES', accessedRoutes)
              commit('SET_SETTING', true)
              resolve(accessedRoutes)
            })
            .catch((err) => {
              reject(err)
            })
        } else if (type === 'outsource') {
          let accessedRoutes = getters.isPersonnelOutsource ? personnelMaps : enterpriseMaps
          commit('SET_ROUTES', accessedRoutes)
          commit('SET_SETTING', true)
          resolve(accessedRoutes)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/permit.js